/* eslint-disable */
import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelIcon from '@material-ui/icons/Cancel';
import './DeactivateDialogSuperAdmin.css';
import { onboardingService } from '../../services/onboard.service';
import { useHistory } from 'react-router-dom';
import { Dialog } from '@material-ui/core';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    title: {
        flex: '1 1 100%',
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 80,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    deactivateText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit'
    }

}));

export default function DeactivateDialogSuperAdmin(props: any) {
    const classes = useStyles();
    const [deactivationMessage, setdeactivationMessage] = React.useState<any>('');
    const [deactivateTextErrorMessage, setdeactivateTextErrorMessage] = React.useState<boolean>(false);
    const history = useHistory()
    const [deactivationMessageError, setdeactivationMessageError] = React.useState<boolean>(false);
    const [deactivationErrorMessage, setdeactivationErrorMessage] = React.useState<string>("");
    const [submitclassName, setSubmitclassName] = React.useState<string>("");
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const { getCustomerDetails }: any = useSelector((state: any) => state.superAdmin);
    const [selected, setSelected] = React.useState<any>('');
    const [docExpiryAutoDeactivate, setDocExpiryAutoDeactivate] = React.useState<any>(null)
    const userCurrentStatus = sessionStorage.getItem('userCurrentStatus');
    const isStatusPlusComing = sessionStorage.getItem('isStatusPlusComing');
    const statusPlus = sessionStorage.getItem('statusPlus');

    useEffect(() => {
        if (props && props.message) {
            setdeactivationMessage(props.message)
        }
        if (getCustomerDetails?.data?.data?.status === "Deactive") {
            setSubmitclassName("submit-activate-button");
        }
        else if (getCustomerDetails?.data?.data?.status === "Active" && isStatusPlusComing === "true") {
            setSubmitclassName("submit-activate-button");
        }
        else if (getCustomerDetails?.data?.data?.status === "Active" && isStatusPlusComing === "false") {
            setSubmitclassName("submit-deactivate-button");
        }
        else if (userCurrentStatus === "Document expiry issue") {
            setSubmitclassName("submit-activate-button");
        }
        // if(props.dealerStatus=="Deactive"){}
    }, [getCustomerDetails?.data?.data?.status])


    // ONCHANGE OF TEXTAREA-AUTOSIZE 
    const handleCustomerChange = (e: any) => {
        setdeactivationMessage(e.target.value);
        if (e.target.required) {
            if (e.target.value === "" || e.target.value.trim() === "") {
                setdeactivationMessageError(true);
            }
            else {
                setdeactivationMessageError(false);
            }
        }
    }


    const handleChange = (event: any) => {
        setSelected(event.target.value);
        if (event.target.value === "activate") {
            setDocExpiryAutoDeactivate(false);
        } else if (event.target.value === "deactivate") {
            setDocExpiryAutoDeactivate(true);
        }
    };


    // VALIDATION FOR TEXTAREA OF DEACTIVATE MESSAGE 
    function validatedeactivateMessage() {
        let isValid: boolean = true;
        if (getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "false") {
            if (!deactivationMessage || deactivationMessage.trim() === "") {
                setdeactivationMessageError(true);
                setdeactivationErrorMessage("please enter deactivate message");
                isValid = false;
                return
            } else {
                if (deactivationMessage.split('').length > 150) {
                    setdeactivationMessageError(false);
                    setdeactivateTextErrorMessage(true);
                    isValid = false;
                    return
                }
                else {
                    setdeactivationMessageError(false);
                    setdeactivateTextErrorMessage(false);
                }
            }
        }
        if (isValid) {
            deactivateMessageAPI();
            // props.handleopenCloseSnackbar(true);
            // setSuccessMessage('Customer deactivated successfully');
            setdeactivationMessage(null);
        }
    }

    // FOR DEACTIVATE MESSAGE API INTEGRATION
    const deactivateMessageAPI = async () => {
        let action = ""
        if (getCustomerDetails?.data?.data?.status === "Deactive") {
            action = "active"
        }
        else if (getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true") {
            action = "active"
        }
        else if (getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "false") {
            action = "deactive"
        }
        else if (getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "false") {
            action = "deactive"
        } else if (userCurrentStatus == "Document expiry issue") {
            action = docExpiryAutoDeactivate === false ? "active" : "active"
        }
        let payload = {
            "action": action,
            "deactivationReason": docExpiryAutoDeactivate === false ? deactivationMessage : docExpiryAutoDeactivate === true ? "Document expiry issue" : deactivationMessage,
            "docExpiryAutoDeactivate": docExpiryAutoDeactivate,
            "actionTakenBy": sessionStorage.getItem('webApplicationLoginId'),
        }
        let crStatus: any = await onboardingService.deactivateDealer(payload, getCustomerDetails?.data?.data?.sapCustomerId)
        // setOpenSnackbar(true)
        // setSuccessMessage(crStatus.message.message);
        if (crStatus.message.status === "S") {
            props.handleopenCloseSnackbar(true);
            setSuccessMessage(crStatus.message.message);
            setSelected("");
            setTimeout(() => {
                history.push('/superadmindealers');
                props.handleopenClose(false);
            }, 2000)
        } else {
            setOpenSnackbar(false)
            setSuccessMessage(crStatus.message.message);
            props.handleopenClose(false)
        }
    }


    return (
        <Fragment>
            <Dialog
                open={props.open ? true : false}
                onClose={() => { props.handleopenClose(false); props.handleopenCloseSnackbar(false); setSelected(null); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <Snackbar
                    open={props.openRequestSnackbar ? true : false}
                    handleopenClose={() => { props.handleopenCloseSnackbar(false); setdeactivationMessage(null); }} message={successMessage}
                />
                <DialogContent>
                    <div className={classes.root}>
                        {
                            getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "false" ?
                                <div className="col-12 mt-0">
                                    <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                        <h4 className="shift-to-party-page-title px-3">
                                            <IconButton aria-label="close" className="float-right pr-4 mt-2 px-3"
                                                onClick={() => { props.handleopenClose(false); setSelected(null); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </h4>
                                    </Typography>
                                </div> : ""}
                        {/* {
                            userCurrentStatus === "Document expiry issue" ?
                                <div className="col-12 mt-0">
                                    <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                        <h4 className="shift-to-party-page-title px-3">
                                            <IconButton aria-label="close" className="float-right pr-4 mt-2 px-3"
                                                onClick={() => { props.handleopenClose(false); setSelected(null); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </h4>
                                    </Typography>
                                </div> : ""} */}
                        <DialogContent>
                            {
                                getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "false" ?
                                    <div className={classes.icon}>
                                        <CancelIcon className="deactivate-meesage-warning" fontSize="small" />
                                    </div>
                                    : ""}
                            <div>
                                <DialogContentText id="alert-dialog-description">
                                    <div className={`mt-3 ${classes.deactivateText}`}>
                                        <h6 className="mb-0 fontweight-superadmin px-2 mb-3">{userCurrentStatus === "Document expiry issue" ? "Are you sure to activate ?" : getCustomerDetails?.data?.data?.status == "Deactive" ? "Are you sure to activate ?" : getCustomerDetails?.data?.data?.status == "Active" && userCurrentStatus !== "Document expiry issue" ? "Are you sure to deactivate ?" : "Are you sure to deactivate ?"}</h6>
                                    </div>
                                </DialogContentText>
                            </div>
                        </DialogContent>
                    </div>
                    {/* {userCurrentStatus === "Document expiry issue" || getCustomerDetails?.data?.data?.status === "Deactive"  ? */}
                    {getCustomerDetails?.data?.data?.status === "Deactive" || getCustomerDetails?.data?.data?.status === "Active" && getCustomerDetails?.data?.data?.blockIntent === true && isStatusPlusComing === "false" ?
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 p-0 mb-2">
                            <div className="col-12 border-top w-100 p-0">
                                <div className=' justify-content-around' id="demo-radio-buttons-group-label">
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="BANK"
                                        name="radio-buttons-group"
                                        onChange={handleChange} value={selected}
                                    >
                                        <div className="row">
                                            <div className={"col"}>
                                                <FormControlLabel className={"col font-size-15 mx-2"}
                                                    value="activate" control={<Radio color="primary" />}
                                                    label="Activate" />
                                            </div>
                                            <Tooltip title="To be used in case of Document issues" placement="top">
                                                <div className={"col pr-3"}>
                                                    <FormControlLabel className={"col font-size-15 pr-2"}
                                                        disabled={statusPlus && statusPlus === "Manual" ? true : statusPlus && statusPlus === "T&C" ? true : statusPlus && statusPlus === "Doc" ? false : statusPlus && statusPlus === "Manual,T&C" ? true : statusPlus && statusPlus === "Manual,Doc" ? false : statusPlus && statusPlus === "T&C,Doc" ? false : statusPlus && statusPlus === "Manual,T&C,Doc" ? false : false}
                                                        value="deactivate" control={<Radio color="primary" />}
                                                        label="Temporarily Activate for 7 days" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        : ""}
                    {getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true" ?
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 p-0 mb-2">
                            <div className="col-12 border-top w-100 p-0">
                                <div className=' justify-content-around' id="demo-radio-buttons-group-label">
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="BANK"
                                        name="radio-buttons-group"
                                        onChange={handleChange} value={selected}
                                    >
                                        <div className="row">
                                            <div className={"col"}>
                                                <FormControlLabel className={"col font-size-15 mx-2"}
                                                    // disabled={statusPlus && statusPlus === "Manual" ? false : statusPlus && statusPlus === "T&C" ? false : statusPlus && statusPlus === "Doc" ? false : statusPlus && statusPlus === "Manual,T&C" ? false : statusPlus && statusPlus === "Manual,Doc" ? false : statusPlus && statusPlus === "T&C,Doc" ? false : statusPlus && statusPlus === "Manual,T&C,Doc" ? false : false}
                                                    value="activate" control={<Radio color="primary" />}
                                                    label="Activate" />
                                            </div>
                                            <Tooltip title="To be used in case of Document issues" placement="top">
                                                <div className={"col pr-3"}>
                                                    <FormControlLabel className={"col font-size-15 pr-2"}
                                                        disabled={statusPlus && statusPlus === "Manual" ? true : statusPlus && statusPlus === "T&C" ? true : statusPlus && statusPlus === "Doc" ? false : statusPlus && statusPlus === "Manual,T&C" ? true : statusPlus && statusPlus === "Manual,Doc" ? false : statusPlus && statusPlus === "T&C,Doc" ? false : statusPlus && statusPlus === "Manual,T&C,Doc" ? false : false}
                                                        value="deactivate" control={<Radio color="primary" />}
                                                        label="Temporarily Activate for 7 days" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        : ""}
                    {
                        getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "false" ?
                            <div className="row col-md-12 mb-1 mt-0 px-5">
                                <div className="col-sm-12 col-md-12 px-4 pr-2 mb-0 mt-0">
                                    <div className="col-6">
                                        <TextareaAutosize value={deactivationMessage}
                                            // maxLength={250}
                                            aria-label="minimum height" minRows={6} placeholder="Reason.." className="textArea-correction p-4"
                                            onChange={(e: any) => handleCustomerChange(e)}
                                        />
                                    </div>
                                </div>

                                {deactivationMessageError &&
                                    <span className="col-12 px-5" style={{ color: 'red' }}>Please enter reason for Deactivation.</span>
                                }
                                {deactivateTextErrorMessage &&
                                    <span className="col-12 px-5" style={{ color: 'red' }}>Upto 150 characters are allowed.</span>
                                }
                            </div>
                            : props.message && props.message.length > 0 ? <div className="col-sm-12 col-md-12 px-4 pr-2 mb-0 mt-0">
                                <div className="col-6">
                                    <TextareaAutosize disabled={true} value={deactivationMessage}
                                        // maxLength={250}
                                        aria-label="minimum height" minRows={6} placeholder="Reason.." className="textArea-correction p-4"
                                        onChange={(e: any) => handleCustomerChange(e)}
                                    />
                                </div>
                            </div> : ""}
                </DialogContent>
                <div className="row-space-start col-12 mb-2 mt-0">
                    <div className="col-12 m-0 p-0">
                        <div className="row mb-0 px-2">
                            <div className="col-12 mt-2">
                                <div className="d-flex align-items-center">
                                    <div className="row-space-start ml-auto">
                                        <DialogActions className="mt-3 mb-1 justify-content-end">
                                            <Button variant="contained"
                                                color="secondary" className={userCurrentStatus === "Document expiry issue" && !selected ? `activate-disabled-button ${submitclassName}` : getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true" && !selected ? `activate-disabled-button ${submitclassName}` : getCustomerDetails?.data?.data?.status === "Deactive" && !selected ? `activate-disabled-button ${submitclassName}` : getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "true" ? `${submitclassName}` : `${submitclassName}`}
                                                onClick={() => { validatedeactivateMessage(); }}
                                                disabled={userCurrentStatus === "Document expiry issue" && !selected ? true : getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true" && !selected ? true : getCustomerDetails?.data?.data?.status === "Deactive" && !selected ? true : getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "true" ? false : false}
                                            >{userCurrentStatus === "Document expiry issue" ? "Yes" : getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true" ? "Yes" : getCustomerDetails?.data?.data?.status === "Deactive" ? "Yes" : getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "true" ? "Submit" : "Submit"}
                                            </Button>
                                            <Button variant="contained" className={classes.closeButton}
                                                onClick={() => { props.handleopenClose(false); setSelected(null); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); }}
                                            >{userCurrentStatus === "Document expiry issue" ? "No" : getCustomerDetails?.data?.data?.status == "Active" && isStatusPlusComing === "true" ? "No" : getCustomerDetails?.data?.data?.status === "Deactive" ? "No" : getCustomerDetails?.data?.data?.status === "Active" && userCurrentStatus !== "Document expiry issue" && isStatusPlusComing === "true" ? "Cancel" : "Cancel"}
                                            </Button>
                                        </DialogActions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
}
